import { render, staticRenderFns } from "./ConstruirNumero.vue?vue&type=template&id=abbf104e&scoped=true"
import script from "./ConstruirNumero.vue?vue&type=script&lang=js"
export * from "./ConstruirNumero.vue?vue&type=script&lang=js"
import style0 from "./ConstruirNumero.vue?vue&type=style&index=0&id=abbf104e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf104e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VIcon,VProgressLinear,VRow,VTextField})
